'use strict';

var _ = require('lodash');
function FlightSummaryBookingIntakeToggleButtonsController($scope) {
  var DEFAULT_VIEW = 'default';
  var INTAKE_PERFORMANCE_VIEW = 'intake-performance';
  var DEFAULT_OPTIONS = {
    selected: false,
    disabled: false
  };
  $scope.toggleModes = {};
  $scope.selectedMode = DEFAULT_VIEW;
  $scope.toggleModes[DEFAULT_VIEW] = Object.assign({}, DEFAULT_OPTIONS, {
    label: 'Default View',
    value: DEFAULT_VIEW,
    selected: true
  });
  $scope.toggleModes[INTAKE_PERFORMANCE_VIEW] = Object.assign({}, DEFAULT_OPTIONS, {
    label: 'Performance Intake',
    value: INTAKE_PERFORMANCE_VIEW
  });
  $scope.isReachedSelectLimit = function (selectionMode) {
    try {
      return !selectionMode.selected && _.size($scope.gridPanelScope.syncGridApply('getselectedrowindexes')) > 100;
    } catch (e) {
      return true;
    }
  };
  $scope.toggleMode = function (currentMode) {
    if ($scope.selectedMode === currentMode) {
      return;
    }
    _.forEach($scope.toggleModes, function (mode) {
      mode.selected = false;
    });
    $scope.toggleModes[currentMode].selected = true;
    $scope.toggleModes[currentMode].disabled = false;
    $scope.selectedMode = currentMode;
    $scope.changeColumns(currentMode);
  };
}
FlightSummaryBookingIntakeToggleButtonsController.$inject = ['$scope'];
module.exports = FlightSummaryBookingIntakeToggleButtonsController;